import { render, staticRenderFns } from "./LuGlobalGrid.vue?vue&type=template&id=8720191e&"
import script from "./LuGlobalGrid.vue?vue&type=script&lang=js&"
export * from "./LuGlobalGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.0_babel-co_0dbbf42f62185882c0604707ed980ddd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports